export default __webpack_public_path__ + "static/media/main_info_data_06.16600f51.png";